// eslint-disable-next-line import/prefer-default-export
export const SUBGROUPS_WITH_LABEL_NEW = [
  { id: 'earnings-log', expiryDate: new Date('2023-11-10') },
  { id: 'member-inspector', expiryDate: new Date('2023-11-10') },
  { id: 'api-domain', expiryDate: new Date('2024-01-30') },
  { id: 'video-tutorials', expiryDate: new Date('2024-04-30') },
];
